import { Box } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { UC_SERVICES } from 'consent/usercentricsConfig';
import { useServiceConsent } from 'consent/useServiceConsent';
import { getYoutubeEmbedUrl, isYouTubeUrl } from 'utils/youtube';
import { YouTubeConsentPlaceholder } from './YouTubeConsentPlaceholder';

type Props = {
  embedUrl: string;
  title: string;
};

export const ConsentGatedYouTubeEmbed = ({ embedUrl, title }: Props): ReactElement => {
  const hasConsent = useServiceConsent(UC_SERVICES.youtube);
  const resolvedEmbedUrl = isYouTubeUrl(embedUrl) ? getYoutubeEmbedUrl(embedUrl) : embedUrl;

  if (hasConsent !== true) {
    return (
      <Box
        position="absolute"
        inset={0}
        overflow="hidden"
        borderRadius="xl"
        bg="background.canvas"
        isolation="isolate"
        zIndex={1}
      >
        <YouTubeConsentPlaceholder title={title} />
      </Box>
    );
  }

  return (
    <iframe
      title={title}
      src={resolvedEmbedUrl}
      width="100%"
      height="100%"
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};
